import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Smartphone, Sparkles, Bell, Rocket } from "lucide-react";

const fade = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.12 } }),
};

export default function Apps() {
  return (
    <div className="grain min-h-screen relative bg-[#0A0A0A] overflow-hidden" data-testid="apps-page">
      <Navbar />

      {/* Ambient glow */}
      <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 h-[420px] w-[420px] rounded-full bg-[#D90429]/20 blur-[120px]" />
      <div className="pointer-events-none absolute bottom-0 right-0 h-[300px] w-[300px] rounded-full bg-[#D90429]/10 blur-[120px]" />

      <section className="relative z-10 px-6 md:px-12 lg:px-20 py-20 md:py-28 min-h-[70vh] flex flex-col items-center justify-center text-center">
        <motion.div variants={fade} initial="hidden" animate="show" custom={0}
          className="inline-flex items-center gap-2 border border-[#D90429]/40 bg-[#D90429]/10 px-4 py-1.5 mb-8">
          <Sparkles className="h-4 w-4 text-[#D90429]" />
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-[#D90429]">Ceinaru Media Labs</span>
        </motion.div>

        <motion.div variants={fade} initial="hidden" animate="show" custom={1}
          className="mb-8 relative">
          <div className="h-24 w-24 md:h-28 md:w-28 mx-auto border border-white/10 bg-black/40 backdrop-blur-xl flex items-center justify-center relative">
            <Smartphone className="h-11 w-11 md:h-12 md:w-12 text-[#D90429]" strokeWidth={1.5} />
            <motion.span
              animate={{ scale: [1, 1.15, 1], opacity: [0.6, 0.2, 0.6] }}
              transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
              className="absolute inset-0 border border-[#D90429]/40" />
          </div>
        </motion.div>

        <motion.h1 variants={fade} initial="hidden" animate="show" custom={2}
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[0.95]">
          Our apps are<br /><span className="text-[#D90429] text-glow">coming soon.</span>
        </motion.h1>

        <motion.p variants={fade} initial="hidden" animate="show" custom={3}
          className="mt-6 text-base md:text-lg text-[#A0A0A0] max-w-xl leading-relaxed">
          We're building a lineup of Android apps for artists, producers and studios.
          Google&nbsp;Play links will land right here the moment they go live.
        </motion.p>

        <motion.div variants={fade} initial="hidden" animate="show" custom={4}
          className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 w-full max-w-3xl">
          {[
            { icon: Rocket, t: "Built by Ceinaru Media", d: "Crafted with the same obsession as our records." },
            { icon: Smartphone, t: "Android first", d: "Distributed through the Google Play Store." },
            { icon: Bell, t: "Launching in stages", d: "New tools rolling out one release at a time." },
          ].map((f) => (
            <div key={f.t} className="border border-white/10 bg-black/30 backdrop-blur-sm p-6 text-left hover:border-[#D90429]/40 transition-colors">
              <f.icon className="h-6 w-6 text-[#D90429] mb-3" strokeWidth={1.5} />
              <h3 className="font-display text-base font-bold mb-1.5">{f.t}</h3>
              <p className="text-sm text-[#A0A0A0] leading-relaxed">{f.d}</p>
            </div>
          ))}
        </motion.div>

        <motion.p variants={fade} initial="hidden" animate="show" custom={5}
          className="mt-12 inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-white/40">
          <span className="h-1.5 w-1.5 rounded-full bg-[#D90429] animate-pulse" />
          Under construction
        </motion.p>
      </section>

      <Footer />
    </div>
  );
}
